import Vue from 'vue';
import store from './../../store';
import ediOrderTransformer from './../../transformers/ediOrder';
import paginationTransformer from '../../transformers/pagination';

const success = ({ data }, resolve) => {
  const ediOrders = ediOrderTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);

  store.dispatch('fetchPaginatedEdiOrders', { ediOrders, pagination });
  resolve({ ediOrders, pagination });
};

const failed = (error, reject) => reject(error);

export default (
    page = null,
    limit = null,
    search = null,
    sort = null,
    filter = null
    ) => (
  new Promise((resolve, reject) => {
    let url = (!page && !limit) ? 'edi_orders' : `edi_orders?page=${page}&limit=${limit}`;

    if (sort) {
      url += `&sort=${sort}`;
    }
    if (search) {
      url += `${url === 'edi_orders' ? '?' : '&'}search=${search}`;
    }

    if (filter) {
      url += `&${filter}`;
    }
    Vue.$http.get(url)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/ediOrder/items.js